var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { onMounted, readonly, ref } from "vue";
import {} from "@/api/remoteFiles";
import { useFileSourcesStore } from "@/stores/fileSourcesStore";
/**
 * Composable for accessing and working with file sources.
 *
 * @param options - The options to filter the file sources.
 */
export function useFileSources(options = {}) {
    const fileSourcesStore = useFileSourcesStore();
    const isLoading = ref(true);
    const hasWritable = ref(false);
    const fileSources = ref([]);
    onMounted(() => __awaiter(this, void 0, void 0, function* () {
        fileSources.value = yield fileSourcesStore.getFileSources(options);
        hasWritable.value = fileSources.value.some((fs) => fs.writable);
        isLoading.value = false;
    }));
    function getFileSourceById(id) {
        return fileSources.value.find((fs) => fs.id === id);
    }
    function getFileSourceByUri(uri) {
        const sourceId = getFileSourceIdFromUri(uri);
        let matchedFileSource = getFileSourceById(sourceId);
        if (matchedFileSource) {
            return matchedFileSource;
        }
        // Match by URI root if the source ID is not found.
        matchedFileSource = fileSources.value.find((fs) => uri.startsWith(fs.uri_root));
        return matchedFileSource;
    }
    function getFileSourceIdFromUri(uri) {
        var _a, _b;
        const sourceId = (_b = (_a = uri.split("://")[1]) === null || _a === void 0 ? void 0 : _a.split("/")[0]) !== null && _b !== void 0 ? _b : "";
        return sourceId;
    }
    return {
        /**
         * The list of available file sources from the server.
         */
        fileSources: readonly(fileSources),
        /**
         * Whether the file sources are being loaded from the server.
         */
        isLoading: readonly(isLoading),
        /**
         * Whether the user can write files to any of the available file sources.
         */
        hasWritable: readonly(hasWritable),
        /**
         * Get the file source with the given ID.
         *
         * @param id - The ID of the file source to get.
         * @returns The file source with the given ID, if found.
         */
        getFileSourceById,
        /**
         * Get the file source that matches the given URI.
         *
         * @param uri - The URI to match.
         * @returns The file source that matches the given URI, if found.
         */
        getFileSourceByUri,
    };
}
